import {
  InputDataArray,
  GroupLabelType,
  CorporateDataListType,
  CorporateLabelType,
  UsersLabelType,
  LabelDataType,
  CorporateHistoryLabelType,
} from '../types/Corporate';

// 法人新規登録
export const InicialinputData: InputDataArray = {
  corporate: [
    { name: 'temp_corporate_name', label: '法人名(漢字)', type: 'text', value: '' },
    { name: 'temp_corporate_kana_name', label: '法人名(フリガナ)', type: 'text', value: '' },
    { name: 'temp_address', label: '住所(漢字)', type: 'text', value: '' },
  ],
  user1: [
    { name: 'temp_email_1', label: 'メールアドレス', type: 'email', value: '' },
    { name: 'temp_position_name_1', label: '役職名(漢字)', type: 'text', value: '' },
    { name: 'temp_name_1', label: '氏名(漢字)', type: 'text', value: '' },
  ],
  user2: [
    { name: 'temp_email_2', label: 'メールアドレス', type: 'email', value: '' },
    { name: 'temp_position_name_2', label: '役職名(漢字)', type: 'text', value: '' },
    { name: 'temp_name_2', label: '氏名(漢字)', type: 'text', value: '' },
  ],
  user3: [
    { name: 'temp_email_3', label: 'メールアドレス', type: 'email', value: '' },
    { name: 'temp_position_name_3', label: '役職名(漢字)', type: 'text', value: '' },
    { name: 'temp_name_3', label: '氏名(漢字)', type: 'text', value: '' },
  ],
};

export const GroupLabel: GroupLabelType[] = [
  { type: 'corporate', label: '法人情報' },
  { type: 'user1', label: '法人ユーザー情報①' },
  { type: 'user2', label: '法人ユーザー情報②' },
  { type: 'user3', label: '法人ユーザー情報③' },
];

// 法人情報削除
export const CorporateLabelData: CorporateLabelType = {
  id: '法人ID',
  temp_corporate_name: '法人名(漢字)',
  temp_corporate_kana_name: '法人名(フリガナ)',
  temp_address: '住所(漢字)',
  group_name: 'JA名',
  bank_branch_name: '取引店',
  update_user_name: '登録者',
  updated_at: '登録日',
  authorizer_name: '承認者',
  approval_date: '承認日',
};

// 法人ユーザー情報削除
const User1LabelData = {
  temp_email_1: 'メールアドレス',
  temp_position_name_1: '役職名(漢字)',
  temp_name_1: '氏名(漢字)',
};

const User2LabelData = {
  temp_email_2: 'メールアドレス',
  temp_position_name_2: '役職名(漢字)',
  temp_name_2: '氏名(漢字)',
};

const User3LabelData = {
  temp_email_3: 'メールアドレス',
  temp_position_name_3: '役職名(漢字)',
  temp_name_3: '氏名(漢字)',
};

// 法人情報詳細
export const LabelData: LabelDataType = {
  corporate: CorporateLabelData,
  user1: User1LabelData,
  user2: User2LabelData,
  user3: User3LabelData,
};

// 法人情報編集
export const CorporateDataList: CorporateDataListType[] = [
  { name: 'id', label: '法人ID', type: 'default' },
  { name: 'temp_corporate_name', label: '法人名(漢字)', type: 'text' },
  { name: 'temp_corporate_kana_name', label: '法人名(フリガナ)', type: 'text' },
  { name: 'temp_address', label: '住所(漢字)', type: 'text' },
  { name: 'group_name', label: 'JA名', type: 'default' },
  { name: 'bank_branch_name', label: '取引店', type: 'select' },
  { name: 'update_user_name', label: '登録者', type: 'default' },
  { name: 'updated_at', label: '登録日', type: 'default' },
  { name: 'authorizer_name', label: '承認者', type: 'default' },
  { name: 'approval_date', label: '承認日', type: 'default' },
];

// 法人ユーザー情報編集
export const CorporateUserDataList: CorporateDataListType[] = [
  { name: 'temp_email', label: 'メールアドレス', type: 'email' },
  { name: 'temp_position_name', label: '役職名(漢字)', type: 'text' },
  { name: 'temp_name', label: '氏名(漢字)', type: 'text' },
];

export const UsersLabel: UsersLabelType[] = [
  { type: 'user1', label: '法人ユーザー情報①' },
  { type: 'user2', label: '法人ユーザー情報②' },
  { type: 'user3', label: '法人ユーザー情報③' },
];

// 法人情報編集履歴
export const CorporateHistoryLabel: CorporateHistoryLabelType = {
  corporate: [
    { name: 'corporate_id', label: '法人ID' },
    { name: 'corporate_name', label: '法人名(漢字)' },
    { name: 'corporate_kana_name', label: '法人名(フリガナ)' },
    { name: 'address', label: '住所(漢字)' },
    { name: 'ja_name', label: 'JA名' },
    { name: 'branch_name', label: '取引店' },
  ],
  user1: [
    { name: 'email_1', label: 'メールアドレス' },
    { name: 'position_name_1', label: '役職名(漢字)' },
    { name: 'name_1', label: '氏名(漢字)' },
  ],
  user2: [
    { name: 'email_2', label: 'メールアドレス' },
    { name: 'position_name_2', label: '役職名(漢字)' },
    { name: 'name_2', label: '氏名(漢字)' },
  ],
  user3: [
    { name: 'email_3', label: 'メールアドレス' },
    { name: 'position_name_3', label: '役職名(漢字)' },
    { name: 'name_3', label: '氏名(漢字)' },
  ],
};

// バリデーションエラー時に返されるform_nameの探索キーワード
export const FormNameKey = {
  temp_comment: 'temp_comment',
};

// APIから返却されてくるdetailのitemのkey名
export const ItemKey = {
  approval_date: 'approval_date',
  created_at: 'created_at',
  updated_at: 'updated_at',
  start_date: 'start_date',
  end_date: 'end_date',
}
